// React
import React, { useState, useEffect, useCallback } from "react";

// Kendo
import kendo from "@progress/kendo-ui";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Checkbox } from "@progress/kendo-react-inputs";
import { TimePicker } from "@progress/kendo-react-dateinputs";

// Css
import "./elderBehavior.css"
import styles from "./elderBehavior.module.css"

// Service
import { getUser, isAdmin, isDeveloper, isLogin } from "../../../service/authService";
import { getBehaviorList, getUserBehaviorList, insertUserBehavior } from "../../../service/mngt/elderService";
import DateTimePickerKo from '../../com/dateInputs/dateTimePickerKo';
import { parseDate } from "../../../com/dateUtil";
import TimePickerKo from "../../com/dateInputs/timePickerKo";

// Component
import { Delete } from "@material-ui/icons";

const ElderBehaviorAdd = ({ conn, elderInfo, setElderInfo, getUserBehaviorListCallback, selectedDay }) => {

  const userInfo = getUser();

  // 데이터 저장
  const [data, setData] = useState({
    behaviorDefault: { behaviorTerm: "행동패턴 선택" , behaviorCode: null },
    behavior: null,
    behaviorList: [],
  })
  const [behaviorValue, setBehaviorValue] = useState({  behaviorTerm: "행동패턴 선택" , behaviorCode: null })

  // 데이터 상태
  const [dataState, setDataState] = useState({
    userId: elderInfo.dataItem.userId,
    dayofweek: null,
    // selectedDays: [],
    time: null,
    // selectedTimes: [],
    behaviorCode: null,
    behaviorTerm: null,
    behaviorTermOther: null,
    regiId: userInfo.userId,
    regiDtm: parseDate("yyyy-mm-dd hh:mm:ss", new Date()),
    residenceStatus: null, 

    // 리스트 다시 조회
    selectedDay: selectedDay,
  })


  // 행동패턴 저장
  const saveBehavior = () => {
    if(dataState.behaviorCode === null || dataState.behaviorTerm === null) {
      kendo.alert("행동패턴을 선택해주세요.");
    } else if (selectedDays.length === 0) {
      kendo.alert("요일을 선택해주세요.");
    } else if (selectedTimes.length === 0) {
      kendo.alert("시간을 선택해주세요.");
    } else {
      insertUserBehavior(conn, dataState, selectedDays, selectedTimes)
      .then((result) => {
        if ( result === 0 ) {
          kendo.alert("저장이 완료되었습니다.");
          getUserBehaviorList(conn, getUserBehaviorListCallback, getRejection, dataState);
          closeEvt();
        } else {
          kendo.alert("중복된 데이터를 제외하고 저장을 완료하였습니다.");
          getUserBehaviorList(conn, getUserBehaviorListCallback, getRejection, dataState);
          closeEvt();
        }
      })
      .catch((error) => {
        kendo.alert("중복된 데이터가 있습니다.")
        getUserBehaviorList(conn, getUserBehaviorListCallback, getRejection, dataState);
        closeEvt();
        console.log("error ", error);
      })

    }
  }

  // 닫기 이벤트
  const closeEvt = () => {
    setElderInfo(elderInfo => {
      const item = { ...elderInfo };
      item.behaviorAddInfo = false;
      return item;
    });
  };

  const getBehaviorListCallback = result => {
    setData((data) => {
      const item = { ...data };
      item.behaviorList = result;
      return item;
    })

  }

  const getRejection = reject => {
    console.log("getRejection = ", reject);
  };

  // 요일
  const days = ['월요일', '화요일', '수요일', '목요일', '금요일', '토요일', '일요일'];
  const [selectedDays, setSelectedDays] = useState([]);

  const handleClick = (day) => {
    if (selectedDays.includes(day)) {
      setSelectedDays(selectedDays.filter((selectedDay) => selectedDay !== day));
    } else {
      setSelectedDays([...selectedDays, day]);
    }
  };

  // 시간
  const [startTime, setStartTime] = useState(new Date(2023, 1, 1, 0, 0, 0));
  const [endTime, setEndTime] = useState(new Date(2023, 1, 1, 0, 0, 0));
  const [selectedTimes, setSelectedTimes] = useState([]);
  const handleTimeChange = (newStart, newEnd) => {
    const startHour = newStart.getHours();
    const endHour = newEnd.getHours();
    const range = [];

    if (startHour <= endHour) {
      for(let i = startHour; i <= endHour; i++) {
        range.push(i);
      }
    }

    setSelectedTimes(range);
  }

  // 재실 여부
  const [checked, setChecked] = useState({
    checkedY: false,
    checkedN: false,
  })

  const handleChangeY = () => {
    setBehaviorValue({ behaviorTerm: "행동패턴 선택" , behaviorCode: null })
    setDataState(dataState => {
      const item = { ...dataState };
      item.behaviorCode = null;
      item.behaviorTerm = null;
      item.behaviorTermOther = null;
      return item;
    })
    setChecked(checked => {
      const item = { ...checked };
      item.checkedY = !checked.checkedY;
      return item;
    })
    if (checked.checkedN) {
      setChecked(checked => {
        const item = { ...checked };
        item.checkedN = false;
        return item;
      })
    }
    if (!checked.checkedY) {
      setDataState(dataState => {
        const item = { ...dataState };
        item.residenceStatus = 'Y';
        getBehaviorList(conn, getBehaviorListCallback, getRejection, item);
        return item;
      })
    } else {
      setData((data) => {
        const item = { ...data };
        item.behaviorList = [];
        return item;
      })
    }
  };

  const handleChangeN = () => {
    setBehaviorValue({ behaviorTerm: "행동패턴 선택" , behaviorCode: null })
    setDataState(dataState => {
      const item = { ...dataState };
      item.behaviorCode = null;
      item.behaviorTerm = null;
      item.behaviorTermOther = null;
      return item;
    })
    setChecked(checked => {
      const item = { ...checked };
      item.checkedN = !checked.checkedN;
      return item;
    })
    if (checked.checkedY) {
      setChecked(checked => {
        const item = { ...checked };
        item.checkedY = false;
        return item;
      })
    }
    if (!checked.checkedN) {
      setDataState(dataState => {
        const item = { ...dataState };
        item.residenceStatus = 'N';
        getBehaviorList(conn, getBehaviorListCallback, getRejection, item);
        return item;
      })
    } else {
      setData((data) => {
        const item = { ...data };
        item.behaviorList = [];
        return item;
      })
    }
  };

  // 행동패턴 선택
  const handleChangeBehavior = event => {

    setBehaviorValue({ behaviorCode: event.target.value.behaviorCode, behaviorTerm: event.target.value.behaviorTerm})
    dataState.behaviorCode = event.target.value.behaviorCode;
    dataState.behaviorTerm = event.target.value.behaviorTerm;
    
  }

  // 행동패턴 기타
  const behaviorTermOtherChange = event => {
    setDataState((dataState) => {
      const item = { ...dataState };
      item.behaviorTermOther = event.target.value;
      return item;
    })
  }

  return (
    <Dialog title={"행동패턴 추가"} onClose={closeEvt}>
      <div className={styles.behaviorAddDialog}>
        <div className={styles.category2}>
          <span className={styles.residenceStatusSpan}>재실여부</span>
          <Checkbox className={styles.residenceStatusCheckbox} label="Y" checked={checked.checkedY} onChange={handleChangeY} />
          <Checkbox className={styles.residenceStatusCheckbox} label="N" checked={checked.checkedN} onChange={handleChangeN} />
        </div>
        <div className={styles.category}>
          <DropDownList
            className={styles.behaviorListDropdown}
            data={data.behaviorList}
            textField = "behaviorTerm" 
            dataItemKey="behaviorCode"
            defaultItem={data.behaviorDefault}
            disabled={data.behaviorList.length === 0 && checked.checkedY === false && checked.checkedN === false}
            onChange={handleChangeBehavior}
            value={behaviorValue}
          />
        </div>
        {dataState.behaviorTerm === "기타" &&
          <div className={styles.category}>
            <input className={styles.behaviorTermOtherInput} type="text" value={dataState.behaviorTermOther} onChange={behaviorTermOtherChange} placeholder="EX) 병원, 교회 등" />
          </div>
        }
        <div className={styles.category}>
          <span className={styles.residenceStatusSpan}>요일 설정</span><br/>
          {days.map((day, index) => (
            <Button
              className={styles.daysButton}
              key={index}
              onClick={() => handleClick(day)}
              style={{ color: selectedDays.includes(day)? '#fff' : '#686a6d', backgroundColor: selectedDays.includes(day) ? '#7aa6e5' : '#fff' }}
            >
              {day.substring(0, 1)}
            </Button>
          ))}
          {/* <div>선택한 요일: {selectedDays.join(', ')}</div> */}
        </div>
        <div className={styles.category}>
          <span className={styles.residenceStatusSpan}>시간 설정</span><br/>
          <TimePickerKo
            className={styles.timesTimePicker}
            format={"HH 시"}
            value={startTime}
            onChange={(e) => {
                setStartTime(e.value);
                handleTimeChange(e.value, endTime);
            }}
          />
          &nbsp;~&nbsp;
          <TimePickerKo
            className={styles.timesTimePicker}
            format={"HH 시"}
            value={endTime}
            onChange={(e) => {
                setEndTime(e.value);
                handleTimeChange(startTime, e.value);
            }}
          />
          {/* <div>선택된 시간 범위: {selectedTimes.join(', ')}</div> */}
          {/* <TimePickerKo format={"HH"}/>
          ~
          <TimePickerKo format={"HH"}/> */}
        </div>
        <div className={styles.categoryButton}>
          <Button onClick={saveBehavior}>추가</Button>
          <Button onClick={closeEvt}>취소</Button>
        </div>
      </div>
    </Dialog>
  );
};
export default ElderBehaviorAdd;
